/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Protocol_Field_Hair_ClearInputs */

const en_us2_body_assessment_protocol_field_hair_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Hair_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hair over the outline`)
};

const pt_br2_body_assessment_protocol_field_hair_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Hair_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cabelo sobre o contorno`)
};

const es_419_body_assessment_protocol_field_hair_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Hair_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cabello sobre el contorno`)
};

const pt_pt2_body_assessment_protocol_field_hair_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Hair_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cabelo sobre o contorno`)
};

const fr_fr2_body_assessment_protocol_field_hair_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Hair_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cheveux sur la silhouette`)
};

const de_de2_body_assessment_protocol_field_hair_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Hair_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haare über dem Umriss`)
};

const it_it2_body_assessment_protocol_field_hair_clear = /** @type {(inputs: Body_Assessment_Protocol_Field_Hair_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`capelli sulla sagoma`)
};

/**
* | output |
* | --- |
* | "hair over the outline" |
*
* @param {Body_Assessment_Protocol_Field_Hair_ClearInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_protocol_field_hair_clear = /** @type {((inputs?: Body_Assessment_Protocol_Field_Hair_ClearInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Protocol_Field_Hair_ClearInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_protocol_field_hair_clear(inputs)
	if (locale === "es-419") return es_419_body_assessment_protocol_field_hair_clear(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_protocol_field_hair_clear(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_protocol_field_hair_clear(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_protocol_field_hair_clear(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_protocol_field_hair_clear(inputs)
	return en_us2_body_assessment_protocol_field_hair_clear(inputs)
});
export { body_assessment_protocol_field_hair_clear as "body-assessment.protocol_field.hair_clear" }